import { HTMLAttributes, ReactElement, ReactNode } from 'react';
import styles from './SpinnerContainer.module.scss';
import classes from 'classnames/bind';

const cx = classes.bind(styles);

interface SpinnerContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const SpinnerContainer = ({ children, className, ...rest }: SpinnerContainerProps): ReactElement => {
  return (
    <div className={cx('spinner-container', className)} {...rest}>
      {children}
    </div>
  );
};
